<template>
  <div>
    <SampleSearchForm :listForm="searchList" @handlerSearch="onSearch" />
    <CommonTable
      ref="CommonTable"
      :loading="tableLoading"
      :tableHead="tableHeadTab"
      :tableData="tableDataTab"
      :tableParam="tableParamTab"
      :showCheckbox="false"
      @page-size-change="pageSizeChange"
    >
      <!-- 查看详情 -->
      <template #codeSlot="{ row }">
        <span class="detail-text-class" @click="toUpdate(row, 'detail')">{{
          row.code
        }}</span>
      </template>
      <template #operationSlot="{ row }">
        <el-button
          type="text"
          @click="examine(row)"
          v-hasPermission="'outside-warehouse-manage/outside-feedback-result'"
          >反馈采用结果</el-button
        >
      </template>
    </CommonTable>
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="是否采用" prop="isUse">
          <DictSelect
            type="cml_common_whether"
            :value="ruleForm.isUse"
            @change-emit="isUseChange"
          />
        </el-form-item>
        <el-form-item v-if="ruleForm.isUse === 'NO'" label="理由" prop="reason">
          <el-input
            type="textarea"
            placeholder="请输入内容"
            maxlength="30"
            show-word-limit
            v-model="ruleForm.reason"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confirmBtn" :loading="submitLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog center top="5vh" :visible.sync="detailDialogVisible" width="1200px">
      <OutsideSample v-if="detailDialogVisible && status === 'detail'" :id="id" :detailId="detailId" />
      <div v-if="status === 'detail'" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable';
import SampleSearchForm from '@/components/SampleSearchForm';
import DictSelect from '@/components/DictSelect';
import OutsideSample from '@/components/OutsideSample';
export default {
  components: { CommonTable, SampleSearchForm, DictSelect, OutsideSample },
  props: {
    addBtn: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      searchList: {
        list: [
          {
            tag: 'el-input',
            label: '寻样单编号',
            prop: 'code',
            defaultValue: undefined,
            placeholder: '请输入完整寻样单编号',
          },
          {
            tag: 'el-input',
            label: '产品名称',
            prop: 'productName',
            defaultValue: undefined,
            placeholder: '请输入关键字',
          },
        ],
      },
      listForm: { detailStatus: 'GET' },
      tableLoading: false,
      tableParamTab: {
        pageNo: 1,
        pageSize: 100,
        orderBy: '',
      },
      tableHeadTab: [
        { label: '产品名称', prop: 'productName' },
        {
          label: '寻样单编号',
          prop: 'code',
          slotColumn: true,
          slotName: 'codeSlot',
        },
        { label: '申请时间', prop: 'createDate', width: 140 },
        { label: '数量', prop: 'num', width: 80 },
        { label: '单位', prop: 'unit', width: 80 },
        { label: '样品类型', prop: 'productTypeName', width: 80 },
        { label: '供应商', prop: 'supplierName' },
        { label: '申请人', prop: 'demandStaffName' },
        { label: '需求品牌', prop: 'demandBrandName' },
        { label: '用途', prop: 'purpose' },
        { label: '特殊备注', prop: 'specialRemark' },
        {
          label: '操作',
          prop: 'operation',
          slotColumn: true,
          slotName: 'operationSlot',
          width: 120,
        },
      ],
      tableDataTab: {},
      selectTab: {},
      ruleForm: {
        reason: '',
        isUse: '',
      },
      dialogVisible: false,
      rules: {
        reason: [{ required: true, message: '请输入理由', trigger: 'blur' }],
        isUse: [
          { required: true, message: '请选择是否采用', trigger: 'change' },
        ],
      },
      submitLoading: false,
      detailDialogVisible: false,
      status: '',
      id: '',
      detailId: ''
    };
  },
  computed: {},
  mounted() {
    this.getList();
    this.$refs.CommonTable.changeHeight();
  },
  methods: {
    // 查询
    onSearch(val) {
      this.tableParamTab.pageNo = 1;
      this.listForm = { ...this.listForm, ...val };
      this.getList();
    },
    // table数据
    getList() {
      const params = {
        ...this.tableParamTab,
        data: this.listForm,
      };
      this.tableLoading = true;
      this.$http.outsideSampleManage
        .getOrderCompleteInfo(params)
        .then(result => {
          this.tableDataTab = result.data;
          this.selectTab = [];
          this.$refs.CommonTable.clearCheckboxRow();
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    isUseChange(val) {
      this.ruleForm.isUse = val;
      this.ruleForm.reason = '';
    },
    // 翻页
    pageSizeChange(pageNo, pageSize) {
      this.tableParamTab.pageNo = pageNo;
      this.tableParamTab.pageSize = pageSize;
      this.getList();
    },
    // 反馈采用结果
    examine(row) {
      this.selectTab = row;
      this.dialogVisible = true;
    },
    confirmBtn() {
      this.$refs.ruleForm.validate(valid => {
        if (!valid) return false;
        const params = { ...this.ruleForm, ...this.selectTab, id: this.selectTab.detailId };
        this.submitLoading = true;
        this.$http.outsideSampleManage
          .addFeedback(params)
          .then(() => {
            this.$message.success('反馈成功');
          })
          .catch(err => {
            this.$message.error(err.msg);
          })
          .finally(() => {
            this.getList();
            this.submitLoading = false;
            this.handleClose();
          });
      });
    },
    handleClose() {
      this.$refs.ruleForm.resetFields();
      this.dialogVisible = false;
      this.ruleForm = {
        reason: '',
        isUse: '',
      };
    },
    toUpdate(row, status) {
      this.status = status;
      this.id = row.id;
      this.detailId = row.detailId;
      this.detailDialogVisible = true;
      if(status === 'update') {
        this.$nextTick(() => {
          this.$refs.outsideApplySample.getDetail(row.id);
        })
      }
    }
  },
};
</script>

<style lang="less" scoped>
</style>
